import { useEffect, useRef, useState } from "react";
import AdminPanelCountries from "../../../components/shared/countries-admin-panel/AdminPanelCountries";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import { CountriesService } from "../../../services/countries.service";
import { CountryDeatilsDataType } from "../../../interface/site.interface";
import styles from "./ForeignLocations.module.scss";
import copy from "../../../assets/images/copy-icon/Copy.svg";
import copied from "../../../assets/images/copy-icon/Copied.svg";
import Spinner from "../../../components/shared/spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";

const ForeignLocations = () => {
  const language = useSelector((state: RootState) => state.language.language);
  const [countryDetails, setCountryDetails] =
    useState<CountryDeatilsDataType | null>(null);
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(
    null
  );
  const dispatch = useDispatch<AppDispatch>();

  const [copiedTextIndex, setCopiedTextIndex] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { userInfo } = useSelector((state: RootState) => state.userProfile);
  const [showEngData, setShowEngData] = useState(false);
  const [selectedCountryName, setSelectedCountryName] = useState<string | null>(
    null
  );

  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    if (selectedCountryId !== null) {
      CountriesService.getCountryDetails()
        .then((res) => {
          const allCountries = res?.data;
          const countryData = allCountries?.[selectedCountryId.toString()];

          if (countryData) {
            setCountryDetails(countryData);
            setShowEngData(false);
          } else {
            setCountryDetails(null);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [selectedCountryId]);

  const fallbackCopy = (text: string, index: number) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand("copy");
      setCopiedTextIndex(index);
    } catch (err) {
      console.error("Fallback copy failed", err);
    }
    document.body.removeChild(textarea);
  };

  const copyToClipboard = (text: string, index: number) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedTextIndex(index);
          setTimeout(() => setCopiedTextIndex(null), 1000);
        })
        .catch((err) => {
          fallbackCopy(text, index);
        });
    } else {
      fallbackCopy(text, index);
    }
  };

  const selectedData = showEngData
    ? countryDetails?.eng_data
    : countryDetails?.original_data;

  const handleCountrySelect = (id: number, name: string) => {
    setSelectedCountryId(id);
    setSelectedCountryName(name);
  };

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  return (
    <div id={styles.forign_locations}>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_foreign_address
            ? `${data?.colibri} | ${data?.auth_foreign_address}`
            : "Colibri"
        }
      />
      <AdminPanelCountries onCountrySelect={handleCountrySelect} />
      <div>
        {loading ? (
          <Spinner size="large" />
        ) : countryDetails ? (
          <div className={styles.country_details}>
            {countryDetails?.eng_data?.length > 0 && selectedCountryId && (
              <div className={styles.lang_toggle_buttons}>
                <button
                  className={`${styles.lang_btn} ${
                    !showEngData ? styles.active : ""
                  }`}
                  onClick={() => setShowEngData(false)}
                >
                  En
                </button>
                <button
                  className={`${styles.lang_btn} ${
                    showEngData ? styles.active : ""
                  }`}
                  onClick={() => setShowEngData(true)}
                >
                  {selectedCountryName}
                </button>
              </div>
            )}

            <div className={styles.important_note}>
              <p className={styles.note_title}>{data?.auth_common_note}</p>
              <p className={styles.note_text}>
                Sifariş etdiyiniz məhsulun itməsinin qarşısını almaq üçün
                mağazanın ünvan hissəsindəki Address Line 2-ə "Colibri #
                {userInfo?.id}" nömrənizi qeyd etməyiniz mütləqdir.
              </p>
            </div>

            <div className={styles.country_details_cards}>
              {(selectedData || []).map((detail, index) => (
                <div key={index} className={styles.detail_card}>
                  <p className={styles.detail_title}>{detail.title}</p>
                  <div className={styles.detail_information}>
                    <p>{detail.information}</p>
                    <div
                      className={styles.copy_icon}
                      onClick={() => copyToClipboard(detail.information, index)}
                    >
                      {copiedTextIndex === index ? (
                        <img src={copied} alt="copied" />
                      ) : (
                        <img src={copy} alt="copy" />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className={styles.no_data}>
            <p>Heç bir məlumat yoxdur</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForeignLocations;
